import React from 'react';
import IcelandTripTap from "./tabs/IcelandTripTap";
import IcelandProgramTab from "./tabs/IcelandProgramTab";
import IcelandAccommodationTab from "./tabs/IcelandAccommodationTab";
import IcelandPriceTab from "./tabs/IcelandPriceTab";
import IcelandEssentialTab from "./tabs/IcelandEssentialTab";
import TabsSection from "../common/TabsSection";


const IcelandTripDetailsSection = () => {
    return (
        <TabsSection tabs={
            [
                <IcelandTripTap/>,
                <IcelandProgramTab/>,
                <IcelandAccommodationTab/>,
                <IcelandPriceTab/>,
                <IcelandEssentialTab/>
            ]}>
        </TabsSection>
    );
}

export default IcelandTripDetailsSection;
